export const REGEX_MATCH_YOUTUBE = /(?:youtube(?:-nocookie)?\.com\/(?:[^\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/
// to remove image not from yahoo cdn
export const REGEX_DENY_IMG = /(<img [^>]*src=[^>]*>)/g
export const REGEX_REPLACE_INVALID_IMG = /(<img [^>]*src="(?!(https?:)?\/\/(s\.yimg\.com|sandbox\.mrs\.mobile\.yahoo\.com|ct\.yimg\.com)[^"]*)(.[^"]*)"[^>]*>)/g
export const REGEX_REPLACE_INVALID_YOUTUBE_IFRAME = /(<iframe [^>]*src="((https?:)?\/\/(?!(www\.youtube\.com\/|youtu.be\/))[^"]+)"[^>]*>*<\/iframe[^>]*>)/g
export const REGEX_REPLACE_LINK = /^(https?:\/\/|ssh:\/\/|ftp:\/\/|file:\/)(.[^\s]+)/i
export const YOUTUBE_EMBED_URL_PREFIX = 'https://www.youtube.com/embed/'
export const YOUTUBE_IFRAME_WIDTH_SIZE = 640

// <img> 不允許以下 inline style
export const INVALID_STYLES_IMG = 'max-width max-height min-width min-height'
